<template>
  <div class="macro-bar">
    <div class="header">
      Protéines, glucides, lipides
    </div>

    <div class="bar">
      <div class="section protein" :style="{ width: proteinInternal + '%' }"></div>
      <div class="section glucides" :style="{ width: glucidesInternal + '%' }"></div>
      <div class="section lipides" :style="{ width: lipidesInternal + '%' }"></div>
    </div>

    <div class="legend">
      <div class="item">
        <span class="color-box protein"></span>
        Protéines ({{ protein }}%)
        <div class="warning" v-if="isOutOfRange(protein, 15, 25)">
          (idéal : 15–25%)
        </div>
      </div>
      <div class="item">
        <span class="color-box glucides"></span>
        Glucides ({{ glucides }}%)
        <div class="warning" v-if="isOutOfRange(glucides, 40, 55)">
          (idéal : 40–55%)
        </div>
      </div>
      <div class="item">
        <span class="color-box lipides"></span>
        Lipides ({{ lipides }}%)
        <div class="warning" v-if="isOutOfRange(lipides, 30, 40)">
          (idéal : 30–40%)
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProteinGlucidesLipidesBar',
  props: {
    protein: Number,
    glucides: Number,
    lipides: Number
  },
  data() {
    return {
      proteinInternal: 0,
      glucidesInternal: 0,
      lipidesInternal: 0,
    };
  },
  methods: {
    isOutOfRange(value, min, max) {
      return value < min || value > max;
    }
  },
  watch: {
    protein: {
      immediate: true,
      handler(newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.proteinInternal = newVal;
          }, 10);
        });
      }
    },
    glucides: {
      immediate: true,
      handler(newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.glucidesInternal = newVal;
          }, 10);
        });
      }
    },
    lipides: {
      immediate: true,
      handler(newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.lipidesInternal = newVal;
          }, 10);
        });
      }
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 6px;
}

.macro-bar {
  font-family: sans-serif;
  margin-bottom: 20px;
}

.bar {
  display: flex;
  height: 20px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px #ccc;
  margin-bottom: 10px;
}

.section {
  height: 100%;
  transition: width 0.6s ease-in-out;
}

.protein {
  background-color: #64b5f6;
}

.glucides {
  background-color: #fff176;
}

.lipides {
  background-color: #ffb74d;
}

.legend {
  display: flex;
  justify-content: space-around;
  font-size: 14px;
}

.legend .item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.color-box {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  margin-right: 6px;
  display: inline-block;
}

.warning {
  color: #e53935;
  font-size: 12px;
  margin-top: 2px;
}
</style>
